<template lang="pug">
#plating
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_plating.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_plating_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 Metalize
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 Under vacuum conditions, a metal element is deposited on the surface  by steam or sputtering. In this way, a very thin coating on surface can be obtained, and it has the outstanding advantages of fast speed and good adhesion.
  section#product_profile
    b-row.menu
      b-col.text-center.position-relative(:class="{ active: p_show[0].show }" @click='change("PVC")') PVC
      b-col.text-center(:class="{ active: p_show[1].show }" @click='change("APET")') APET
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5(:class="{ active: p_show[0].show }" @click='change("PVC")') 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p This product is steamed with metal film, and then processed into a variety of different colors with metallic luster electroplating tape. It is suitable for making all kinds of glittering and dazzling Christmas ribbon ornaments, sequins for clothing, labels, and tape. In addition, it can be vacuum-formed as a packaging material for various high-end gifts and food to enhance the value of the product.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
      b-row#apet_detail.detail.pb-5.py-md-5(:class="{ active: p_show[1].show }" @click='change("APET")') 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p This product is developed for electroplating purposes. The tape has good  steaming deposition effect, no oil spots and good flatness. After metallized coating, it is suitable for packaging boxes such as chocolate and general food.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5(:class="{ active: p_show[0].show }" @click='change("PVC")') 
    div.mask
    h2.text-center 
      span PVC Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_4
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.vcm")
        <div class="swiper-pagination" slot="pagination"></div>
  section#specification.py-5(:class="{ active: p_show[1].show }" @click='change("APET")') 
    div.mask
    h2.text-center 
      span  APET Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_1
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 Others
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'PVC / APET Metalize-NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'Metalized PVC is steamed with metal film, and then processed into a variety of different colors with metallic luster electroplating tape. It is suitable for making all kinds of glittering and dazzling Christmas ribbon ornaments, sequins for clothing, labels, and tape. There are laser process, decoration, etc.Metallized APET is developed for electroplating purposes. The tape has good steaming deposition effect, no oil spots and good flatness. After metallized coating, it is suitable for packaging boxes such as chocolate and general food. There are food grade vaccum molding.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, PVC, APET, Metalize, Laser, Decoration' },
            { name: 'og:title', content: 'PVC / APET Metalize-NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'Metalized PVC is steamed with metal film, and then processed into a variety of different colors with metallic luster electroplating tape. It is suitable for making all kinds of glittering and dazzling Christmas ribbon ornaments, sequins for clothing, labels, and tape. There are laser process, decoration, etc.Metallized APET is developed for electroplating purposes. The tape has good steaming deposition effect, no oil spots and good flatness. After metallized coating, it is suitable for packaging boxes such as chocolate and general food. There are food grade vaccum molding.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: 'Metalize',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/processing_Desktop/plating_img_01.jpg',
            img_alt: 'Nanya PVC electroplating is suitable for making various ribbons, sequins, labels, tapes, and APET electroplating is suitable for chocolate and food packaging boxes.' },
          { 
            id: '2',
            img_src: 'img/processing_Desktop/plating_img_02.jpg',
            img_alt: 'Nanya PVC electroplating is suitable for making various ribbons, sequins, labels, tapes, and APET electroplating is suitable for chocolate and food packaging boxes.' },
          { 
            id: '3',
            img_src: 'img/processing_Desktop/plating_img_03.jpg',
            img_alt: 'Nanya PVC electroplating is suitable for making various ribbons, sequins, labels, tapes, and APET electroplating is suitable for chocolate and food packaging boxes.' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: 'Good Glossy' },
          { message: 'Excellent vacuum steamability' },
          { message: 'REACH, ROHS certificated' }
        ],
        p_use: [
          { message: 'Customized：Corona、Cold resitance, Heat resistance, Weather resistance, Flame Resistance, Anti-static' },
          { message: 'Test：ASTM D-1593, ASTM D-792, JIS-K6734' }
        ],
        a_feature: [
          { message: 'Good metal steaming effect' },
          { message: 'Good flattening' }
        ],
        a_use: [
          { message: 'Customied：Corona, Weather resistance, anti-static, Anti-fog, High frequency' },
          { message: 'Test Mothd：ASTM D-1593, ASTM D-792, ASTM D-1003, ASTM D-523' }
        ],
        p_specification: [
          { 
            id: '1',
            name: 'VMMA(Laser Process)',
            feature: 'Features: high gloss, good bonding between metal and PET',
            outward: 'Appearance: Clear, Color',
            thickness: 'Thickness<sub>(mm)</sub>：0.05',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>490/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/><span class="pl-5">MD>75/CD>25</span>',
            heating: 'Heat Shrinkage<sub>(%,100°CX10min)</sub>：<br/><span class="pl-5">Unregulated</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' },
          { 
            id: '2',
            name: 'VMMD(Decoration package)',
            feature: 'Features: high gloss, good bonding between metal and PET',
            outward: 'Appearance: Clear, Color, gloss, matt',
            thickness: 'Thickness<sub>(mm)</sub> ：0.05',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>490/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub> ：<br/><span class="pl-5">MD>75/CD>25</span>',
            heating: 'Heat Shrinkage<sub>(%,100°CX10min)</sub>：<br/><span class="pl-5">Unregulated</span>',
            vcm: 'VCM(ppm)</sub>：Unregulated' },
          { 
            id: '3',
            name: 'VMMF(Vaccum forming for food)',
            feature: 'Features: high gloss, excellent vacuum forming ability',
            outward: 'Appearance: Clear, Color',
            thickness: 'Thickness<sub>(mm)</sub> ：0.23',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/> <span class="pl-5">MD>400/CD>380</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/> <span class="pl-5">MD>135/CD>90</span>',
            heating: 'Heat Shrinkage<sub>(%,100°CX10min)</sub>：<br/> <span class="pl-5">MD＞-6/CD<3</span>',
            vcm: 'VCM<sub>(ppm)</sub>：<1' },
          { 
            id: '4',
            name: 'VZZM(Metallized)',
            feature: 'Features: high gloss, good bonding between metal and PET',
            outward: 'Appearance: Clear, Color, gloss, matt',
            thickness: 'Thickness<sub>(mm)</sub> ：0.045',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/> <span class="pl-5">MD>490/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/> <span class="pl-5">MD>75/CD>25</span>',
            heating: 'Heat Shrinkage<sub>(%,100°CX10min)</sub>：<br/> <span class="pl-5">Unregulated</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' }
        ],
        a_specification: [
          { 
            id: '1',
            name: 'AMFF(Food grade Vaccum forming)',
            feature: 'Features: Good metal steaming effect',
            outward: 'Appearance: Clear, Color',
            thickness: 'Thickness<sub>(mm)</sub>：0.25',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>:<br/><span class="pl-5">88～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub>：<br/><span class="pl-5">155～165</span>',
            mist: 'Haze<sub>(%)</sub>：<br/><span class="pl-5">≦3.0</span>'}
        ],
        swiperOption_pvc: {
          slidesPerView: 4,
          spaceBetween: 30,
          breakpoints: {
            1550: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption_apet: {
          slidesPerView: 1,
          spaceBetween: 30,
          breakpoints: {
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'Vacuum Molding',
            text:'A flat plastic sheet is formed into a three-dimensional curved package by blister equipment which use high temperature and molds, so that consumers can directly see the product and protect it.',
            url:'./img/processing_Desktop/other_pic_pro_1.jpg',
            href_link: 'vacuum_forming'
          },
          {
            id:'2',
            name:'Fold Molding',
            text:'The semi-finished product of the box sheet that has been processed by printing, glazing, die-cutting, etc., is glued, folded, and glued according to the molding requirements of the box body to make a box body that can be used for packaging.',
            url:'./img/processing_Desktop/other_pic_pro_2.jpg',
            href_link: 'folding_forming'
          },
          {
            id:'3',
            name:'Heat Sealing',
            text:'Dielectric heat sealing for high frenquency heat sealing application.target as plastics staged between high electrodes sheet. Subject be fusioned and heat sealing with suitable temperature.',
            url:'./img/processing_Desktop/other_pic_pro_3.jpg',
            href_link: 'heat_seal'
          },
          {
            id:'4',
            name:'Printing',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing for majority of Printing process',
            url:'./img/processing_Desktop/other_pic_pro_4.jpg',
            href_link: 'print'
          },
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#plating
  #specification
    background-image: url(../assets/bg/bg_plating.jpg)


</style>
